var _defs, _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgInstagramIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "ig-instagram-icon",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 28.072,
    height: 28.064,
    viewBox: "0 0 28.072 28.064",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient",
    cx: 0.266,
    cy: 1.077,
    r: 0.991,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fd5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#fd5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#ff543e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#c837ab"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-2",
    cx: -0.168,
    cy: 0.072,
    r: 0.443,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#3771c8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.128,
    stopColor: "#3771c8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#60f",
    stopOpacity: 0
  })))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_66252",
    "data-name": "Path 66252",
    d: "M14.037,0C8.177,0,6.463.006,6.13.034a6.964,6.964,0,0,0-2.766.7A5.6,5.6,0,0,0,1.751,1.909,6.023,6.023,0,0,0,.126,5.323,25.331,25.331,0,0,0,0,9.466c0,1.117,0,2.588,0,4.561,0,5.855.006,7.567.035,7.9A7.05,7.05,0,0,0,.7,24.638a5.913,5.913,0,0,0,3.832,3.131,9.958,9.958,0,0,0,2.038.27c.348.015,3.89.026,7.436.026s7.09,0,7.429-.022a9.589,9.589,0,0,0,2.111-.276,5.877,5.877,0,0,0,3.832-3.137,6.934,6.934,0,0,0,.662-2.659c.019-.242.027-4.1.027-7.947s-.009-7.7-.028-7.941A6.856,6.856,0,0,0,27.366,3.4a5.563,5.563,0,0,0-1.2-1.646A6.06,6.06,0,0,0,22.747.129,25.3,25.3,0,0,0,18.606,0Z",
    transform: "translate(0.003 0)",
    fill: "url(#radial-gradient)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_66253",
    "data-name": "Path 66253",
    d: "M14.037,0C8.177,0,6.463.006,6.13.034a6.964,6.964,0,0,0-2.766.7A5.6,5.6,0,0,0,1.751,1.909,6.023,6.023,0,0,0,.126,5.323,25.331,25.331,0,0,0,0,9.466c0,1.117,0,2.588,0,4.561,0,5.855.006,7.567.035,7.9A7.05,7.05,0,0,0,.7,24.638a5.913,5.913,0,0,0,3.832,3.131,9.958,9.958,0,0,0,2.038.27c.348.015,3.89.026,7.436.026s7.09,0,7.429-.022a9.589,9.589,0,0,0,2.111-.276,5.877,5.877,0,0,0,3.832-3.137,6.934,6.934,0,0,0,.662-2.659c.019-.242.027-4.1.027-7.947s-.009-7.7-.028-7.941A6.856,6.856,0,0,0,27.366,3.4a5.563,5.563,0,0,0-1.2-1.646A6.06,6.06,0,0,0,22.747.129,25.3,25.3,0,0,0,18.606,0Z",
    transform: "translate(0.003 0)",
    fill: "url(#radial-gradient-2)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "Path_66254",
    "data-name": "Path 66254",
    d: "M28.364,18c-2.814,0-3.168.012-4.273.063a7.605,7.605,0,0,0-2.515.481,5.3,5.3,0,0,0-3.032,3.031,7.57,7.57,0,0,0-.481,2.515C18.013,25.2,18,25.549,18,28.363s.013,3.167.063,4.272a7.616,7.616,0,0,0,.481,2.515,5.3,5.3,0,0,0,3.03,3.032,7.611,7.611,0,0,0,2.516.481c1.105.05,1.458.063,4.273.063s3.167-.012,4.272-.063a7.616,7.616,0,0,0,2.517-.481,5.31,5.31,0,0,0,3.031-3.032,7.681,7.681,0,0,0,.481-2.515c.05-1.105.063-1.458.063-4.272s-.013-3.168-.063-4.273a7.678,7.678,0,0,0-.481-2.515,5.3,5.3,0,0,0-3.031-3.031,7.629,7.629,0,0,0-2.517-.481c-1.105-.05-1.457-.063-4.273-.063Zm-.93,1.868h.93c2.767,0,3.095.01,4.188.06a5.737,5.737,0,0,1,1.924.357,3.434,3.434,0,0,1,1.966,1.967,5.726,5.726,0,0,1,.357,1.924c.05,1.092.06,1.421.06,4.186s-.011,3.094-.06,4.186a5.731,5.731,0,0,1-.357,1.924,3.436,3.436,0,0,1-1.966,1.966,5.717,5.717,0,0,1-1.924.357c-1.092.05-1.421.06-4.188.06s-3.1-.011-4.188-.06a5.748,5.748,0,0,1-1.924-.357,3.433,3.433,0,0,1-1.967-1.966,5.726,5.726,0,0,1-.357-1.924c-.05-1.092-.06-1.421-.06-4.188s.01-3.094.06-4.186a5.737,5.737,0,0,1,.357-1.924,3.434,3.434,0,0,1,1.967-1.967,5.725,5.725,0,0,1,1.924-.357c.956-.043,1.326-.056,3.258-.058ZM33.9,21.588a1.243,1.243,0,1,0,1.244,1.243A1.243,1.243,0,0,0,33.9,21.588Zm-5.532,1.453a5.321,5.321,0,1,0,5.321,5.322,5.322,5.322,0,0,0-5.321-5.322Zm0,1.868a3.454,3.454,0,1,1-3.454,3.454A3.454,3.454,0,0,1,28.364,24.909Z",
    transform: "translate(-14.33 -14.33)",
    fill: "#fff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInstagramIcon);
export default __webpack_public_path__ + "static/media/instagram-icon.aab3949f551861afcfa330fe075f576b.svg";
export { ForwardRef as ReactComponent };